import { Observable, Subject} from 'rxjs'
import { Injectable} from '../injector'
import { AuthService } from '../auth/AuthService'

export function observeAjax<T>(url: string, ajaxOpts: JQuery.AjaxSettings): Observable<T> {
	return new Observable((subscriber) => {
		const internalSubject = new Subject()
		let opts = {
			...ajaxOpts,
			success: (data: T) => {
				internalSubject.next(data)
				internalSubject.complete()
			},
			error: (e: any) => internalSubject.error(e),
		}

		AuthService.getAccessToken().then(accessToken => {
			opts = {
				...opts,
				headers: { Authorization: 'Bearer ' + accessToken },
			}
			$.ajax(url, opts)
		})

		return internalSubject.subscribe(subscriber)
	})
}

const jsonSettings = {
	contentType: 'application/json',
	dataType: 'json',
	xhrFields: {
		withCredentials: true
	},
	crossDomain: true
}

export function httpGet<T = {}>(url: string): Observable<T> {
	return observeAjax(url, {
		...jsonSettings,
		type: 'GET',
	})
}

export function httpPost<T = {}, R = {}>(url: string, data: T): Observable<R> {
	return observeAjax(url, {
		...jsonSettings,
		type: 'POST',
		data: JSON.stringify(data),
	})
}

export function httpPut<T = {}, R = {}>(url: string, data: T): Observable<R> {
	return observeAjax(url, {
		...jsonSettings,
		type: 'PUT',
		data: JSON.stringify(data),
	})
}

export function httpDelete<T = void>(url: string): Observable<T> {
	return observeAjax(url, {
		...jsonSettings,
		type: 'DELETE',
	})
}

@Injectable()
export class HttpService {
	http = observeAjax

	httpGet = httpGet
	httpPost = httpPost
	httpPut = httpPut
	httpDelete = httpDelete
}